import { render, staticRenderFns } from "./ManageAccounts.vue?vue&type=template&id=224be462&scoped=true&"
import script from "./ManageAccounts.vue?vue&type=script&lang=js&"
export * from "./ManageAccounts.vue?vue&type=script&lang=js&"
import style0 from "./ManageAccounts.vue?vue&type=style&index=0&id=224be462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224be462",
  null
  
)

export default component.exports